import BasicInfo from "../Trials/BasicInfo";
import MainAccordion from "../Accordion/MainAccordion";

const BasicInfoAccordion = ({
  setMessage,
  setTypeOfMessage,
  setisEvent,
  isEvent,
  setSelectedTrialType,
}) => {
  return (
    <MainAccordion
      title="Basic Trial Information"
      data={
        <BasicInfo
          setMessage={setMessage}
          setTypeOfMessage={setTypeOfMessage}
          isEvent={isEvent}
          setisEvent={setisEvent}
          setSelectedTrialType={setSelectedTrialType}
        />
      }
      isOpen={true}
    />
  );
};
export default BasicInfoAccordion;
